export const moneyRequestPaymentStatus = {
    INIT: 'init',
    SUCCESS: 'success',
    FAIL: 'failed',
}
